import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from "lodash";
import {countPowerSourcesByType, getPowerSourceAtSelectedLocation, isPowerSourceLastOfType} from "../../../../../store/reducers/powerSources";
import {getAllPowerSourcesData, IPowerSource} from "../../../../../data/data";
import {getSelectedLocation} from "../../../../../store/reducers/location";
import {removePowerSourceAtLocation} from "../../../../../store/actions/powerSources";
import {showNextOutageQuestion} from "../../../../../store/actions/questions/questions";
import StatMetre from "./StatMetre";
import {getSeasonIndex} from "../../../../../store/reducers/season";
import Button from "../../../../common/ui/button/Button";

interface IPowerSourceDetailsProps
{
    onClose: () => void;
    power_source: IPowerSource;
    selected_location: number;
    is_damaged: boolean;
    counts: PowerSourceCounts;
    season_index: number;
    target_cost_per_mw: number;
    removePowerSourceAtLocation: (location_id: number) => void;
    showQuestion: () => void;
}

import './PowerSourceDetails.scss';
import {getTargetCostPerMw} from "../../../../../store/reducers/outputs/costPerMw";
import {isPowerSourceDamaged} from '../../../../../store/reducers/power-sources/damage';
import CloseButton from '../CloseButton';
import {PowerSourceCounts} from '../../../../../store/reducers/savedPowerSourceCounts';


class PowerSourceDetails extends React.Component<IPowerSourceDetailsProps, null>
{
    constructor(public props: IPowerSourceDetailsProps)
    {
        super(props);
    }


    /**
     * remove the selected power source
     */
    removePowerSource = () =>
    {
        this.props.removePowerSourceAtLocation(this.props.selected_location);
    };

    getEnergyOutput = () : string =>
    {
        const {power_source} = this.props;
        const {'energy-output':energy_output} = power_source;

        const max: number = _.max(_.map(getAllPowerSourcesData(), 'energy-output'));

        return energy_output / max / 0.01 + '%';
    };

    getCostPerMw = () : string =>
    {
        const {power_source} = this.props;
        const {'cost-per-mw': cost_per_mw} = power_source;

        const max: number = _.max(_.map(getAllPowerSourcesData(), 'cost-per-mw'));

        return cost_per_mw / max / 0.01 + '%';
    };

    getEnvironmentalImpact = () : string =>
    {
        const {power_source} = this.props;
        const {'environmental-impact': environmental_impact} = power_source;

        const max: number = _.max(_.map(getAllPowerSourcesData(), 'environmental-impact'));

        return environmental_impact / max / 0.01 + '%';
    };


    render()
    {
        const {power_source, is_damaged, removePowerSourceAtLocation, selected_location, counts} = this.props;
        if (! power_source) return null;

        const {removable} = power_source;

        const {
            id,
            label,
            description,
            'cost-per-mw': cost_per_mw,
            'energy-output': energy_output,
            'environmental-impact': environmental_impact,
        } = power_source;

        // console.log(power_source);
        // console.log(energy_output);
        // console.log(cost_per_mw);
        // console.log(environmental_impact);

        return <span>

            <div styleName={'content'}>

                <CloseButton onClose={this.props.onClose}/>

                <div styleName={"image-and-stats"}>

                    <div styleName={"image"} style={{ backgroundImage: `url(img/game/power-sources/info/${id}.jpg)` }}>

                        {/*<img className={'details'} src={`img/game/power-sources/info/${id}.jpg`} />*/}

                    </div>

                    {/*<div styleName={"stats"}>

                        <h3 styleName={'stats-title'}>Stats</h3>

                        <StatMetre
                            label={'energy output'}
                            icon={'energy-output'}
                            value={this.getEnergyOutput()}/>

                        <StatMetre
                            label={'cost per MW'}
                            icon={'cost-per-mw'}
                            value={this.getCostPerMw()}/>

                        <StatMetre
                            label={'environmental impact'}
                            icon={'environmental-impact'}
                            value={this.getEnvironmentalImpact()}/>

                    </div>*/}

                    <div styleName={'title-container'}>

                    <h4 styleName={'headline'}>{label}</h4>
                    <h3 styleName={'sub-headline'}>power station</h3>

                    </div>

                </div>

                <div styleName={'text'}>

                    <p styleName={'body-copy'} dangerouslySetInnerHTML={{ __html: description }}></p>

                    {(removable !== false && counts[power_source.id] > 1) &&
                    <div styleName={'ui'}>

                        <Button
                            type={'remove-power-source'}
                            onClick={() => removePowerSourceAtLocation(selected_location)}>remove</Button>

                    </div>}
                </div>

            </div>

        </span>;
    }
}



/**
 * map the state to props
 * @param state
 */
const mapStateToProps = (state, props) =>
{
    return {
        power_source: getPowerSourceAtSelectedLocation(state),
        selected_location: getSelectedLocation(state),
        is_damaged: isPowerSourceDamaged(state, props),
        season_index: getSeasonIndex(state),
        target_cost_per_mw: getTargetCostPerMw(state),
        counts: countPowerSourcesByType(state),
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        removePowerSourceAtLocation: (location_id: number) => dispatch(removePowerSourceAtLocation(location_id)),
        showQuestion: () => dispatch(showNextOutageQuestion())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerSourceDetails);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/power-source-details/PowerSourceDetails.tsx